import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import { useSelector } from "react-redux";

import ReactError from "./ReactError";
import ServerError from "./ServerError";
import NotFound from "./NotFound";

function Error({ children }) {
  const history = useHistory();
  const error = useSelector((state) => state.error);

  const isRender =
    error.status === null || error.status === 400 || error.status === 401;

  const errorHandler = (error, info) => {
    //TODO 센트리, 서버 백로그 사용 가능
    console.log(error);
  };

  useEffect(() => {
    if (error.status === 401) {
      history.push("/auth");
    }
  }, [error, history]);

  return (
    <ErrorBoundary FallbackComponent={ReactError} onError={errorHandler}>
      {error.status === 500 && <ServerError />}
      {error.status === 404 && <NotFound />}
      {isRender && children}
    </ErrorBoundary>
  );
}

export default Error;
